/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SkillChildProgressBulkUpsert } from '../model/skillChildProgressBulkUpsert';
import { SkillChildProgressRead } from '../model/skillChildProgressRead';
import { SkillChildProgressUpsert } from '../model/skillChildProgressUpsert';
import { SkillGroupProgressRead } from '../model/skillGroupProgressRead';
import { SkillGroupProgressUpsert } from '../model/skillGroupProgressUpsert';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioSkillProgressService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Bulk upsert skill progress for multiple children. Uses get_or_create logic to prevent duplicates.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillChildProgressBulkCreate(body: SkillChildProgressBulkUpsert, observe?: 'body', reportProgress?: boolean): Observable<Array<SkillChildProgressRead>>;
    public childPortfolioSkillChildProgressBulkCreate(body: SkillChildProgressBulkUpsert, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SkillChildProgressRead>>>;
    public childPortfolioSkillChildProgressBulkCreate(body: SkillChildProgressBulkUpsert, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SkillChildProgressRead>>>;
    public childPortfolioSkillChildProgressBulkCreate(body: SkillChildProgressBulkUpsert, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling childPortfolioSkillChildProgressBulkCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SkillChildProgressRead>>('post',`${this.basePath}/child-portfolio/skill-child-progress-bulk/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Generic POST upsert:   - Serializer validates owner + skill + optional flags   - get_or_create by (owner_field, skill)   - Apply flags -&gt; *_done_at (True &#x3D;&gt; now, False &#x3D;&gt; None, missing &#x3D;&gt; unchanged) Subclasses must set:   - model: the Django model (e.g., SkillGroupProgress)   - owner_field: str (\&quot;group\&quot; or \&quot;child\&quot;)   - serializer_class: DRF serializer that exposes owner_field &amp; &#x27;skill&#x27; &amp; flags
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillChildProgressCreate(body: SkillChildProgressUpsert, observe?: 'body', reportProgress?: boolean): Observable<SkillChildProgressRead>;
    public childPortfolioSkillChildProgressCreate(body: SkillChildProgressUpsert, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillChildProgressRead>>;
    public childPortfolioSkillChildProgressCreate(body: SkillChildProgressUpsert, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillChildProgressRead>>;
    public childPortfolioSkillChildProgressCreate(body: SkillChildProgressUpsert, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling childPortfolioSkillChildProgressCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SkillChildProgressRead>('post',`${this.basePath}/child-portfolio/skill-child-progress/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Generic POST upsert:   - Serializer validates owner + skill + optional flags   - get_or_create by (owner_field, skill)   - Apply flags -&gt; *_done_at (True &#x3D;&gt; now, False &#x3D;&gt; None, missing &#x3D;&gt; unchanged) Subclasses must set:   - model: the Django model (e.g., SkillGroupProgress)   - owner_field: str (\&quot;group\&quot; or \&quot;child\&quot;)   - serializer_class: DRF serializer that exposes owner_field &amp; &#x27;skill&#x27; &amp; flags
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillGroupProgressCreate(body: SkillGroupProgressUpsert, observe?: 'body', reportProgress?: boolean): Observable<SkillGroupProgressRead>;
    public childPortfolioSkillGroupProgressCreate(body: SkillGroupProgressUpsert, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillGroupProgressRead>>;
    public childPortfolioSkillGroupProgressCreate(body: SkillGroupProgressUpsert, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillGroupProgressRead>>;
    public childPortfolioSkillGroupProgressCreate(body: SkillGroupProgressUpsert, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling childPortfolioSkillGroupProgressCreate.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SkillGroupProgressRead>('post',`${this.basePath}/child-portfolio/skill-group-progress/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
